module.exports = __webpack_public_path__ + "static/media/up_integration_bg.bda2376e.png";